function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// an HOC to add default props to a component
export function withProps(Component, defaultProps) {
    const HOC = (props)=>{
        const _props = _object_spread({}, defaultProps, props);
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, _props));
    };
    // Display name for better debugging
    HOC.displayName = `withProps(${Component.displayName || Component.name || 'Component'})`;
    return HOC;
}
